import type { ReactElement } from 'react';

import { useRequestsUrl } from '../use-requests-url';
import { RequestDetailModal } from './RequestDetailModal';
import { RequestsView } from './RequestsView';

// Vista "Solicitudes" de la Lista Maestra (G3-1, D11): la bandeja con sus filtros en la
// URL y el detalle de la solicitud abierta (?solicitud=<id>, el enlace del aviso).

export function RequestsPanel({ canSeeAll }: { canSeeAll: boolean }): ReactElement {
  const url = useRequestsUrl();
  return (
    <>
      <RequestsView
        status={url.status}
        mine={url.mine}
        page={url.page}
        canSeeAll={canSeeAll}
        onStatus={url.setStatus}
        onMine={url.setMine}
        onPage={url.setPage}
        onOpen={url.open}
      />
      {url.openId !== null && <RequestDetailModal id={url.openId} onClose={url.close} />}
    </>
  );
}
